<template>
  <v-simple-table
    class="rounded-card pb-3 overflow-hidden"
    fixed-header
  >
    <template v-slot:default>
      <thead>
      <tr>
        <th>Código interno</th>
        <th style="min-width: 300px; max-width: 340px">Produto</th>
        <th style="min-width: 108px;" v-if="exibirEstoque">Estoque</th>
        <th style="min-width: 108px;">Quantidade</th>
        <th>Preço unitário</th>
        <th>ICMS</th>
        <th>IPI</th>
        <th>Total</th>
        <th class="text-center" style="min-width: 100px"></th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(produto) in aprovacao.produtos">
        <tr :key="produto.id"
            class="no-hover"
            style="height: 55px">
          <td>
            <px-situacao-user-aprovacao show-as-icon
             :icon-in-right="false" :item-aprovacao="produto"/>
            {{ codigoProduto(produto) }}
          </td>
          <td style="max-width: 300px">
            <px-produto-descricao
              :show-codigo="false"
              :especificacao="produto.especificacaoProdutoOrigem || produto.especificacaoProduto"
              :produto="produto.produto"/>
            <px-show-is-homologado small
                                   :produto="produto.produto"
                                   :id-fornecedor="aprovacao.fornecedor.id"/>
            <v-chip label small v-if="isItemCancelado(produto)"
                    class="ml-2"
                    color="error">
              Cancelado
            </v-chip>
          </td>
          <td v-if="exibirEstoque">
            {{
              produto.saldoEstoque
                | number(getCurrencyFormat(casasDecimaisItem(produto)))
            }}
            {{ produto.unidadeMedida.descricao }}
          </td>
          <td>
            {{
              produto.quantidade
                | number(getCurrencyFormat(casasDecimaisItem(produto)))
            }}
            {{ produto.unidadeMedida.descricao }}
          </td>
          <td>
            {{
              produto.valorMoedaConvertido.precoUnitario
                | currency('R$', produto.produto.casasDecimais)
            }}
            <div class="caption" v-if="isMoedaEstrangeira">
              {{
                produto.precoUnitario
                  | currency(simboloMoeda,
                  produto.produto.casasDecimais,
                  configuracaoFormatacaoMoeda)
              }}
            </div>
          </td>
          <td>
            <px-imposto
              :imposto="produto.impostos"
              show-valor-convertido
              tipo="ICMS"
              :show-aplicacao="false"
              :scale="produto.produto.casasDecimais"/>
            <div v-if="isMoedaEstrangeira">
              <px-imposto
                class="caption"
                :imposto="produto.impostos"
                :simbolo-moeda="simboloMoeda"
                :configuracao-moeda="configuracaoFormatacaoMoeda"
                tipo="ICMS"
                :show-aplicacao="false"
                :scale="produto.produto.casasDecimais"/>
            </div>
          </td>
          <td>
            <px-imposto
              show-valor-convertido
              :imposto="produto.impostos"
              tipo="IPI"
              :show-aplicacao="false"
              :scale="produto.produto.casasDecimais"/>
            <div v-if="isMoedaEstrangeira">
              <px-imposto
                class="caption"
                :imposto="produto.impostos"
                :simbolo-moeda="simboloMoeda"
                :configuracao-moeda="configuracaoFormatacaoMoeda"
                tipo="IPI"
                :show-aplicacao="false"
                :scale="produto.produto.casasDecimais"/>
            </div>
          </td>
          <td>
            <div>
              {{
                produto.valorMoedaConvertido.total | currency('R$', produto.produto.casasDecimais)
              }}
              <px-moeda-chip :moeda="moeda" v-if="isMoedaEstrangeira"/>
              <div class="caption" v-if="isMoedaEstrangeira">
                {{
                  produto.total
                    | currency(simboloMoeda,
                    produto.produto.casasDecimais,
                    configuracaoFormatacaoMoeda)
                }}
              </div>
            </div>
          </td>
          <td class="text-right">
            <px-anexo read-only
                      v-model="produto.arquivos"
                      download-base-path="files/download-comprador"/>
            <px-detalhes-produto
              min-width="350"
              show-projeto
              show-obs-externa
              show-obs-interna
              show-finalidade-compra
              show-data-previsao-entrega
              show-valor-difal
              :show-saving="hasSaving"
              show-centro-custo
              :show-motivo-recusa="isItemRecusado(produto)"
              :produto="produto"
              :casas-decimais="produto.produto.casasDecimais">
              <template v-slot:bottom>
                <px-campos-integracao
                  v-if="cadastrosAdicionaisItem(produto)
                        && showCadastrosAdicionaisItem(produto)"
                  full-width
                  text-class="small-text"
                  type="compra-produtos-view"
                  :form-data="cadastrosAdicionaisItem(produto)"/>
              </template>
            </px-detalhes-produto>
            <px-aprovacao-compra-detalhes-produto-modal-view
              :aprovacao-id="aprovacao.id"
              :item-id="produto.id"
              :fornecedor-id="aprovacao.fornecedor.id"
              @update="onUpdate"/>
            <px-aprovacao-compra-produto-controls :aprovacao-id="aprovacao.id"
                                                  :item-aprovacao="produto"
                                                  @update="onUpdate"/>
            <v-tooltip top v-if="exibirEstoque">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="toggleExpand(produto)">
                  <v-icon>
                    {{ expandedRow === produto.id ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                  </v-icon>
                </v-btn>
              </template>
              <span>Visualizar estoque</span>
            </v-tooltip>
          </td>
        </tr>
        <tr :key="`${produto.id}-expanded`" v-if="expandedRow === produto.id">
          <td colspan="9" class="text-start">
            <px-listagem-estoque :produto-id="produto.produto.id"/>
          </td>
        </tr>
      </template>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { mapGetters } from 'vuex';
import { CasaDecimalUtils } from 'px-components';
import { cadastrosAdicionaisToMap } from '@/utils/campos-integracao-utils';
import moedaMixin from '@/mixins/moeda-mixin';
import AprovacaoCompraDetalhesProdutoModalView
  from '@/modules/aprovacao-compra/detalhes-produtos/AprovacaoCompraDetalhesProdutoModalView.vue';
import AprovacaoCompraProdutoControls
  from '@/modules/aprovacao-compra/components/AprovacaoCompraProdutoControls.vue';
import {
  SituacaoAprovacao,
  SituacaoItemCompra,
  ErpCamposIntegracao,
  TipoProduto,
} from 'px-business-components';
import ListagemEstoque from '@/modules/estoque/ListagemEstoque.vue';

export default {
  mixins: [moedaMixin],
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
    showEstoque: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expandedRow: null,
    };
  },
  computed: {
    ...mapGetters('user', ['user']),
    ...mapGetters('entidade', ['erpCamposIntegracao', 'hasEstoque']),
    moeda() {
      return this.aprovacao.moeda;
    },
    codigoProduto() {
      return item => (item.produto ? item.produto.codigo : '-');
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    casasDecimaisItem() {
      return item => (item.produto ? item.produto.casasDecimais : null);
    },
    showCadastrosAdicionaisItem() {
      return (item) => {
        if (this.erpCamposIntegracao === ErpCamposIntegracao.keys.SENIOR_PFIFFNER.key) {
          return item.produto.tipoProduto === TipoProduto.keys.PRODUTO.key;
        }
        return this.erpCamposIntegracao !== null;
      };
    },
    cadastrosAdicionaisItem() {
      return (item) => {
        if (!item.cadastrosAdicionais || !item.cadastrosAdicionais.length) {
          return null;
        }
        return cadastrosAdicionaisToMap(item.cadastrosAdicionais);
      };
    },
    isItemCancelado() {
      return item => item.situacaoItemCompra === SituacaoItemCompra.keys.CANCELADO.key;
    },
    isItemRecusado() {
      return item => item.situacao === SituacaoAprovacao.keys.RECUSADO.key;
    },
    exibirEstoque() {
      return this.hasEstoque && this.showEstoque;
    },
    hasSaving() {
      return this.aprovacao.saving !== null && this.aprovacao.saving > 0;
    },
  },
  methods: {
    toggleExpand(produto) {
      if (this.expandedRow === produto.id) {
        this.expandedRow = null;
      } else {
        this.expandedRow = produto.id;
      }
    },
    onUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
    },
  },
  components: {
    pxAprovacaoCompraDetalhesProdutoModalView: AprovacaoCompraDetalhesProdutoModalView,
    pxAprovacaoCompraProdutoControls: AprovacaoCompraProdutoControls,
    pxListagemEstoque: ListagemEstoque,
  },
};
</script>
